import { connect } from "react-redux";
import Actions from "../Actions/Creators";
import Phi from "../Phi/Phi";
import NewEpisodes from "./NewEpisodes";

// import { withRouter } from 'react-router-dom';

const mapStateToProps = (state, ownProps) => ({
  organizationId: JSON.parse(Phi.Storage.getItem("organization"))
    ? JSON.parse(Phi.Storage.getItem("organization"))[0].org_id
    : null,
  episodeHeader: state.student.episodeHeader,
  episodeList: state.student.episodeList,
  episodeTotal: state.student.episodeTotal,
  studentHeader: state.student.clinicStudentHeader,
  // newstudent:state.student.newstudent,
  // studentList: state.student.clinicStudentList,
  // studentTotal: state.student.clinicStudentTotal,
  episodeStats: state.student.episodeStats,

  medicaldata: state.student.medicaldata,
  currentProgram: state.organization.currentProgram,
  programs: state.organization.programs,
  startNodeMap:
    state.organization.startNodeMap && state?.organization?.startNodeMap,
});

const mapDispatchToProps = (dispatch) => ({
  fetchEpisodeSearch: (header) =>
    dispatch(Actions.fetchStudentEpisodeSearch(header)),

  // fetchStudentSearch: (header) => dispatch(Actions.fetchClinicStudentSearch(header)),
  // fetchCustomStudentList: (payload, hideLoader) => dispatch(Actions.fetchCustomStudentList(payload, hideLoader)),
  fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),
  // postStudentEpisode: (studentId, customJson, episodeType) => dispatch(Actions.postStudentEpisodeInfo(studentId, customJson, episodeType)),
  // initializeForm: (data) => dispatch(Actions.initializeForm(data)),
  setLoader: () => dispatch(Actions.setLoader()),
  unsetLoader: () => dispatch(Actions.unsetLoader()),
  setSelectedStudent: (payload) =>
    dispatch(Actions.setSelectedStudent(payload)),

  // fetchOverViewReport: (startNode) => dispatch(Actions.fetchOverViewReport(startNode)),
  // changeReportInReducer: (billingId) => dispatch(Actions.changeReportInReducer(billingId)),
  // getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
  // changeReportInReducer: (billingId) => dispatch(Actions.changeReportInReducer(billingId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewEpisodes);
